export const RESULT_TABLE_SETTING_KEYS = [
    'Lav',
    'Lmin',
    'Lmax',
    'UO',
    'UL',
    'Rei',
    'TI',
    'Eav',
    'Emin',
    'Emax',
    'AECI',
    'powerDensity',
    'WetUO',
    'STV',
    'UWLR',
    'LvMax_Lav',
    'Lmax_Lmin',
    'Lav_Lmin',
    'Emin_Emax',
    'Emin_Eav',
];

const STANDARD_SETTING_MAP = {
    LavGreaterThan: 'Lav',
    LMinGreaterThan: 'Lmin',
    LMaxGreaterThan: 'Lmax',
    U0GreaterThan: 'UO',
    WetU0GreaterThan: 'WetUO',
    ULGreaterThan: 'UL',
    ReiGreaterThan: 'Rei',
    TILessThan: 'TI',
    EavGreaterThan: 'Eav',
    EavLessThan: 'Eav',
    EMinGreaterThan: 'Emin',
    EMinLessThan: 'Emin',
    EMaxGreaterThan: 'Emax',
    EMaxLessThan: 'Emax',
    EMinEMaxRatioGreaterThan: 'Emin_Emax',
    EMinEMaxRatioLessThan: 'Emin_Emax',
    EMinEavRatioGreaterThan: 'Emin_Eav',
    EMinEavRatioLessThan: 'Emin_Eav',
    LavLMinRatioGreaterThan: 'Lav_Lmin',
    LavLMinRatioLessThan: 'Lav_Lmin',
    LMaxLMinRatioGreaterThan: 'Lmax_Lmin',
    LMaxLMinRatioLessThan: 'Lmax_Lmin',
    LvMaxLavRatioGreaterThan: 'LvMax_Lav',
    LvMaxLavRatioLessThan: 'LvMax_Lav',
    STVGreaterThan: 'STV',
    STVLessThan: 'STV',
    UWLRLessThan: 'UWLR',
};

const hasStandardValue = (standards, key) =>
    Object.prototype.hasOwnProperty.call(standards, key) &&
    standards[key] !== null &&
    standards[key] !== undefined;

export const getDefaultResultsTableSettings = (roadGrids, baseSettings) => {
    const settings = {
        ...baseSettings,
        SelectAll: false,
        SelectDefault: true,
        SelectNone: false,
    };

    (roadGrids || []).forEach((roadGrid) => {
        const currentStandards = roadGrid.CurrentStandards || {};

        Object.keys(STANDARD_SETTING_MAP).forEach((standardKey) => {
            if (hasStandardValue(currentStandards, standardKey)) {
                settings[STANDARD_SETTING_MAP[standardKey]] = true;
            }
        });
    });

    return settings;
};
